import { ArgsType, Field, Int } from '@nestjs/graphql'
import { UpdateDtoInterface } from '../base/updateDto.interface'

@ArgsType()
export class BaseUpdateDto<T> implements UpdateDtoInterface {
  @Field(t => Int)
  id!: number

  @Field(t => Int, { nullable: true })
  adminForId?: number

  public constructor (partial?: Partial<T>) {
    Object.assign(this, partial)
  }
}
